module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-6739db1f.png";